import { type FacetSearchPayload } from '../types';

export const isFacetSearch = (facetSearch: FacetSearchPayload): boolean => {
    const { searchTerm, style, room, project, creator } = facetSearch;
    return !!searchTerm || [style, room, project, creator].some(facet => facet.length > 0);
};
